<template>
  <div id="app">
    <button @click="login">Login with OAuth2</button>
  </div>
</template>

<script>
import userManager from '../oidc-config';

export default {
  methods: {
    login() {
      userManager.signinRedirect();
    },
    logout() {
      userManager.signoutRedirect();
    }
  }
};
</script>
